import { Box, Card, CardHeader, Container, Grid, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header, HighlightedText, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, slugify, withAuthenticationRequired } from '@tom-ui/utils'
import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router'

export const ContainerJourneyReportPage = withAuthenticationRequired(() => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const theme = useMinimalsTheme()
  const [filter, setFilter] = useState('')

  const reportItems = [
    {
      title: t('containerJourneys', 'Container Journeys'),
      subtitle: t(
        'containerJourneysDescription',
        'View and export container journeys and their associated services.',
      ),
      route: PATHS?.reportsV2?.containerJourneys.url,
    },
  ].sort((a, b) => a.title.localeCompare(b.title))

  return (
    <Box
      sx={{
        height: '100%',
        bgcolor: theme.palette.grey[100],
      }}
    >
      <Helmet>
        <title>{t('reports', 'Reports')}</title>
      </Helmet>
      <Header
        title={t('reports', 'Reports')}
        searchInputLabel={t('search', 'Search')}
        onSearchFieldChange={filter => setFilter(filter)}
        displaySearchIcon
        enableSearchField
      />
      <Container
        sx={{
          paddingY: theme.customSpacing.m,
        }}
      >
        <Grid container spacing={2}>
          {reportItems
            .filter(item => item.title.toLowerCase().includes(filter.toLowerCase()))
            .map((item, index) => (
              <Grid key={index} size={{ xs: 12, md: 6, lg: 3 }}>
                <Card
                  onClick={() => navigate(item.route)}
                  style={{
                    cursor: 'pointer',
                    paddingBottom: theme.customSpacing.l,
                    height: '100%',
                  }}
                  data-cy={`report-card-${slugify(item.title)}`}
                >
                  <CardHeader
                    title={
                      <Typography variant='h3'>
                        <HighlightedText highlight={filter} color={theme.palette.info.main}>
                          {item.title}
                        </HighlightedText>
                      </Typography>
                    }
                    subheader={item.subtitle}
                  />
                </Card>
              </Grid>
            ))}
        </Grid>
      </Container>
    </Box>
  )
})
